import React from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/system";
import styles from "../../AntiBiogramReport.module.css";
import { AntibiogramRow, Antibiotic, Isolate } from "../../antibiogramTypes/AntiBiogramTypes";
import { computeCellStyle, computeCellContent } from "../../util/AntiBiogramUtils";

const StyledTableCell = styled(TableCell)({
  border: "1px solid silver",
  fontFamily: "Arial",
  fontSize: "13px",
  textAlign: "center",
  padding: "5px",
  whiteSpace: "nowrap",
  boxSizing: "border-box",
});

const FirstRow: React.FC<{
  row: AntibiogramRow;
  antibiotics: Antibiotic[];
  rowIndex: number;
  borderBottomLeftRadius?: string;
}> = ({ row, antibiotics, rowIndex, borderBottomLeftRadius }) => {
  return (
    <TableRow>
      {/* First column: Organism Name (Merged across two rows) */}
      <StyledTableCell
        rowSpan={2}
        className={`${styles.noBgColor} ${styles.responsiveNameCell}`}
        style={{
          whiteSpace: "normal",
          wordWrap: "break-word",
          borderBottomLeftRadius,
        }}
      >
        {row.organismName}
      </StyledTableCell>
      {/* Second column: No. Isolates (Merged across two rows) */}
      <StyledTableCell
        rowSpan={2}
        className={`${styles.noBgColor} ${styles.responsiveTotalCell}`}
        // style={{ width: "57px" }}
      >
        {row.sumOfIsolatesPerAntimicrobial}
      </StyledTableCell>
      {/* Third column: Blank header, but first row has %S */}
      <StyledTableCell className={`${styles.noBgColor} ${styles.responsiveTotalCell}`}>%S</StyledTableCell>
      {/* Antibiotic columns */}
      {antibiotics.map((antibiotic) => {
        const isolate: Isolate | undefined = row.isolatesList.find(
          (isolate) => isolate.antimicrobial === antibiotic.groupCode,
        );
        const percOfIsoSentvty = isolate?.percOfIsoSentvty || "-";
        const noOfIsolates = isolate?.isolates?.toString() || "-";
        const resultType = isolate?.result || "-";

        const cellStyle = computeCellStyle(resultType, percOfIsoSentvty);
        const cellContent = computeCellContent(resultType, percOfIsoSentvty, noOfIsolates);

        return (
          <StyledTableCell key={`${rowIndex}-${antibiotic.id}`} className={`${styles[cellStyle]} ${styles.responsiveTotalCell}`}>
            {cellContent}
          </StyledTableCell>
        );
      })}
    </TableRow>
  );
};

export default FirstRow;
